export const scheduleMethods = {
  cron: "Cronjob",
  between: "In bestimmtem Zeitraum",
  unlessBetween: "Außerhalb bestimmten Zeitraums",
  inTimeInterval: "In Zeitintervall",
  everyMinute: "Jede Minute",
  everyFiveMinutes: "Alle fünf Minuten",
  everyTenMinutes: "Alle zehn Minuten",
  everyFifteenMinutes: "Alle 15 Minuten",
  everyThirtyMinutes: "Alle 30 Minuten",
  hourly: "Stündlich",
  hourlyAt: "Stündlich zu bestimmter Uhrzeit",
  daily: "Täglich",
  dailyAt: "Täglich zu bestimmter Uhrzeit",
  at: "Zu bestimmter Zeit",
  twiceDaily: "Zwei mal täglich",
  weekdays: "Unter der Woche",
  weekends: "Am Wochenende",
  mondays: "Montags",
  tuesdays: "Dienstags",
  wednesdays: "Mittwochs",
  thursdays: "Donnerstags",
  fridays: "Freitags",
  saturdays: "Samstags",
  sundays: "Sonntags",
  weekly: "Wöchentlich",
  weeklyOn: "Wöchentlich zu bestimmtem Zeitpunkt",
  monthly: "Monatlich",
  monthlyOn: "Monatlich zu bestimmtem Zeitpunkt",
  twiceMonthly: "Zwei mal monatlich",
  quarterly: "Vierteljährlich",
  yearly: "Jährlich",
  days: "An bestimmten Tagen",
  timezone: "Zeitzone festlegen",
  spliceIntoPosition: "In Positionen unterteilen",
  never: "Nie",
  cronWithParams: "Cronjob: {expression}",
  betweenWithParams: "Zwischen {0} und {0} Uhr",
  unlessBetweenWithParams: "Außer zwischen {0} und {1} Uhr",
  inTimeIntervalWithParams: "Im Zeitintervall {0} und {1} Uhr",
  hourlyAtWithParams: "{0} Min. nach jeder vollen Stunde",
  atWithParams: "Um {0} Uhr",
  dailyAtWithParams: "Täglich um {0} Uhr",
  twiceDailyWithParams: "Zweimal täglich um {0} und {1} Uhr",
  weeklyOnWithParams: "Wöchentlich: {0}, {1} Uhr",
  monthlyOnWithParams: "Monatlich: {0}, {time} Uhr",
  twiceMonthlyWithParams: "Zweimal monatlich: {0}, {1}",
  daysWithParams: "An Tagen: {0}",
  timezoneWithParams: "In Zeitzone {0}",
  spliceIntoPositionWithParams: "In Position {0} mit Wert {1}",
  cronExpressionWithParams: "Cronjob: {expression}",
  nightly: "Nächtlich"
};
